import React from "react";
import { AIAnswerDisclaimer } from "./AIAnswerDisclaimer";
import { AIAnswerFeedback } from "./AIAnswerFeedback";
import { Stack } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

interface AIAnswerFooterProps {
  threadId: string | null;
  messageId: string | null;
  status?: "idle" | "connecting" | "done" | "error";
}

export const AIAnswerFooter: React.FC<AIAnswerFooterProps> = ({
  threadId,
  messageId,
  status,
}) => {
  const isLoading = status === "connecting";
  return isLoading ? (
    <Stack space="xxsmall">
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="20%" />
      <Skeleton variant="text" width="60%" />
    </Stack>
  ) : (
    <>
      {/* Disclaimer only applies to a generated summary — not to idle or failed states */}
      {status === "done" && <AIAnswerDisclaimer />}
      <AIAnswerFeedback
        key={threadId}
        threadId={threadId}
        messageId={messageId}
      />
    </>
  );
};
